// extracted by mini-css-extract-plugin
export default {"wrapper":"QR-z","firstToReview":"RR-z","productCards":"SR-z","productCard":"TR-z","stars":"UR-z","hidden":"VR-z"};